module.exports = function(mess){
  var e = new Error(mess);
  e.jpexInternalError = true;
  throw e;
};



//////////////////
// WEBPACK FOOTER
// ./~/jpex/src/jpexError.js
// module id = 224
// module chunks = 40